module.exports = __webpack_public_path__ + "img/限时商品6.abb9b3b0.png";